export default "__VITE_ASSET__36722988__"